import React,{useEffect, useState} from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Link,useParams,useNavigate } from "react-router-dom";
import { clearErrors, updateBanner, getSingleBanner } from "../../actions/userAction";
import { useAlert } from "react-alert";
import { Button } from "@material-ui/core";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import StorageIcon from "@material-ui/icons/Storage";
import SpellcheckIcon from "@material-ui/icons/Spellcheck";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import DescriptionIcon from "@material-ui/icons/Description";
import MetaData from '../../components/MetaData';
import Loader from "../Loader";
import Sidebar from "./Sidebar";
import { BANNER_UPDATED_RESET } from "../../constants/userConstant";
import { Editor } from '@tinymce/tinymce-react';

const UpdateBanner = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();
	const {id} = useParams();
	const alert = useAlert();

	const { error, banner } = useSelector((state) => state.bannerDetails);

	const { loading, error: updateError, isUpdated } = useSelector((state) => state.banner);

	const [name, setName] = useState("");
	const [status, setStatus] = useState("");
	const [description, setDescription] = useState("");
	const [images, setImages] = useState([]);
	const [oldImages, setOldImages] = useState([]);
	const [imagesPreview, setImagesPreview] = useState([]);

	const handleEditorChange = (content) => {
	    setDescription(content);
	};

	// console.log(banner)
	// console.log(images)

	useEffect(() => {

		if (banner && banner._id !== id) {
	      dispatch(getSingleBanner(id));
	    } else {
	      setName(banner.name);
	      setStatus(banner.status);
	      setDescription(banner.description);
	      setImages(banner.images);
	    }

	    if (error) {
	      alert.error(error);
	      dispatch(clearErrors());
	    }

	    if (updateError) {
	      alert.error(updateError);
	      navigate("/admin/dashboard");
	      dispatch(clearErrors());
	    }

	    if (isUpdated) {
	      alert.success("Banner Updated Successfully");
	      navigate("/admin/banner-list");
	      dispatch({ type: BANNER_UPDATED_RESET });
	    }

	}, [dispatch, alert, error, navigate, id, isUpdated, banner, updateError]);

	const updateBannerImagesChange = (e) => {
	    // Convert FileList to an array and store in state
  const filesArray = Array.from(e.target.files);
  setImages(filesArray);
	};

	const updateBannerSubmitHandler = (e) => {
	    e.preventDefault();

	    const myForm = new FormData();

	    // Append all selected images
		  if (images && images.length > 0) {
		    images.forEach((image) => {
		      myForm.append("images", image);
		    });
		  }

	    myForm.set("name", name);
	    myForm.set("status", status);
	    myForm.set("description", description);
	    // images.forEach((image) => {
	    //   myForm.append("images", image);
	    // });
	    dispatch(updateBanner(id, myForm));
	    // console.log("FormData entries:", [...myForm.entries()]);
	};



	return (
		<>
			{loading ? (
        <Loader />
      ) : (
      	<>

		      		<div className="dashboard-panel">
					<div className="container">
						<MetaData title={`Update Banner`} />
						<div className="row">
							<Sidebar />	
							<div className="col-lg-9 col-md-8">
								<div className="dashboardContainer">
							        <h3>Update Banner</h3>
							        <div className="col-12">
		                    			<form
							            className="createProductForm"
							            encType="multipart/form-data"
							            onSubmit={updateBannerSubmitHandler}
							          >

							          	<div className="single-form">
							              <label>
							              	Banner Name
							              </label>
							              <input
							                type="text"
							                placeholder="Banner Name"
							                required
							                value={name}
							                onChange={(e) => setName(e.target.value)}
							              />
							            </div>
							            
							          
							          	<div className="single-form">
							              <label>
							              	Banner Status
							              </label>
							              <select value={status} onChange={(e) => setStatus(e.target.value)}>
							                <option value="">Choose Status</option>
							                <option value="show">Show</option>
							                <option value="hide">Hide</option>
							              </select>
							            </div>

							            <div className="single-form">
							              <label>
							              	Banner Description
							              </label>
							              {/*<textarea
							                placeholder="Banner Description"
							                value={description}
							                onChange={(e) => setDescription(e.target.value)}
							                cols="10"
							                rows="1"
							              ></textarea>*/}
							              <Editor 
							              	apiKey='511npkfmj2oio25sykoybbl32gny8yfwq0zbl3m5zrkzqoz7'
							              	value={description}
							              	init={{
												height: 500,
												menubar: true,
												plugins: [
													'advlist autolink lists link image charmap print preview anchor',
													'searchreplace visualblocks code fullscreen',
													'insertdatetime media table paste code help wordcount'
												],
												toolbar:
													'undo redo | formatselect | bold italic backcolor | \
				                                    alignleft aligncenter alignright alignjustify | \
				                                    bullist numlist outdent indent | removeformat | help',
				                                    image_uploadtab: true,
											        image_advtab: true, // Enable advanced tab for images
											        file_picker_types: 'image',
											        automatic_uploads: true,
											}}
											onEditorChange={handleEditorChange}
							              />
							            </div>

							            <div className="single-form" id="createCateFormFile">
							            <label>
							              	Banner Image
							              </label>
							              <input
							                type="file"
							                accept="image/*"
							                onChange={updateBannerImagesChange}
							                multiple={true}
							              />
							            </div>

							            {/*<div id="createCateFormImage">
							              {oldImages &&
							                oldImages.map((image, index) => (
							                  <img key={index} src={image.url} alt="Old Banner Preview" />
							                ))}
							            </div>

							            <div className="single-form" id="createCateFormImage">
							              {imagesPreview.map((image, index) => (
							                <img key={index} src={image} alt="Banner Preview" />
							              ))}
							            </div>*/}
							            
							            <button
							            className="mt-2 btn btn-primary btn-hover-dark paymentFormBtn"
							              id="createCateBtn"
							              type="submit"
							              disabled={loading ? true : false}
							            >
							              Create
							            </button>
							          </form>
		  						    </div>
							    </div>
							</div>
						</div>
					</div>
					</div>
</>
		)}
		      	
		</>
	)
}

export default UpdateBanner